export enum StorageIdentifiers {
    FormularyResult = "FORMULARY_RESULT"
}
